(function (scope) {
  "use strict";

  /**
   *
   */
  var PrintThickeningView = (scope.PrintThickeningView = function (
    controller,
    design,
    viewerUI,
    options
  ) {
    this.controller = controller;
    this.design = design;
    this.viewerUI = viewerUI;
    this.viewer = this.viewerUI.viewer;
    this.options = options;

    this.is_active = false;

    this.$el = $("#thickening-settings");
    this.$el.on("click", ".tool-back-default", this.back.bind(this));
    this.$el.on("click", ".tool-reset", this.reset.bind(this));
    this.$el.on("click", ".tool-start", this.activate.bind(this));
  });

  /**
   * if we already have thickening applied
   * @public
   */
  PrintThickeningView.prototype.has_thickening = function () {
    if (this.design.get_operation("ThickenAreasDesignOperation")) {
      this.controller.views.tools.setEnabled(
        sculpteo.PrintToolsView.TOOLS.THICKENING,
        true
      );
    }
  };

  /**
   * Activate thickening UI
   * @public
   */
  PrintThickeningView.prototype.enabled = function () {
    //check if there is already thickening activated on that model
    var op = this.design.get_operation("ThickenAreasDesignOperation");
    if (op !== undefined) {
      this.is_active = true;
      //hide the button start
      $(".tool-start", this.$el).hide();
    }
    $("#thickening-settings").css("left", "10px");
    this.$el.show();
  };

  /**
   * Removes thickening UI
   * @public
   */
  PrintThickeningView.prototype.disabled = function () {
    this.$el.hide();
  };

  /**
   * Back to default view
   */
  PrintThickeningView.prototype.back = function () {
    this.controller.switchTool(sculpteo.PrintToolsView.TOOLS.DASHBOARD);
  };

  /**
   * Activate thickening on the design
   * @private
   */
  PrintThickeningView.prototype.activate = function () {
    if (this.is_active) return;

    this.viewerUI.no_minima = true;
    this.new_geometry(undefined, 1);

    this.is_active = true;

    $(".tool-start", this.$el).hide();
  };

  /**
   * Removes thickening on the design
   * @private
   */
  PrintThickeningView.prototype.reset = function () {
    this.viewerUI.no_minima = false;
    this.update_geometry(2);

    this.is_active = false;

    $(".tool-start", this.$el).show();
  };

  /**
   * Callback on material update to eventually warn the user and update thickening base on material minimum thickness
   * @public
   */
  PrintThickeningView.prototype.materialUpdated = function () {
    return this.update_geometry(0);
  };

  /**
   * Callback on scale update to update thickening
   * @public
   */
  PrintThickeningView.prototype.scaleUpdated = function () {
    return this.update_geometry(0);
  };

  /**
   * Callback on unit update to update thickening
   * @public
   */
  PrintThickeningView.prototype.unitUpdated = function () {
    return this.update_geometry(0);
  };

  PrintThickeningView.prototype.update_geometry = function (type) {
    var op = this.design.get_operation("ThickenAreasDesignOperation");

    if (!op) {
      var dfd = $.Deferred();
      dfd.resolve();
      return dfd;
    }

    return this.new_geometry(op.id, type);
  };

  /**
   * All magic happens here.
   * @private
   * @param {array|undefined} opid - thickening operations ids
   * @param {number} type - What to do : 1: create op, 2, removes it (so it seems)
   */
  PrintThickeningView.prototype.new_geometry = function (opid, type) {
    //show overlay message
    if (type == 1)
      this.controller.overlayNotify(
        sculpteo.PrintOverlayNotification.TYPE.SAVED,
        gettext("Thickening is being applied (this could take a minute)"),
        false
      );
    else if (type == 2)
      this.controller.overlayNotify(
        sculpteo.PrintOverlayNotification.TYPE.RESET,
        gettext("Thickening is being removed"),
        false
      );

    this.viewerUI.clear_measurement_tags(); // ?

    var surface = 0.001;
    var thkid = this.options.thicken.thicken_id;
    var design = this.design;

    var deferred = $.Deferred();
    var deferred_bbox = $.Deferred();
    var deferred_load = $.Deferred();
    var node = this.design.node || this.viewer.getNodesByName("model")[0];

    this.viewer.setLocal(true);

    var listener_bbox = function (minx, miny, minz, maxx, maxy, maxz) {
      var bb_coords = [
        parseFloat(minx),
        parseFloat(miny),
        parseFloat(minz),
        parseFloat(maxx),
        parseFloat(maxy),
        parseFloat(maxz),
      ];

      this.design.size.x = bb_coords[3] - bb_coords[0];
      this.design.size.y = bb_coords[4] - bb_coords[1];
      this.design.size.z = bb_coords[5] - bb_coords[2];
      this.design.size.bbox = bb_coords;

      node.removeEventListener("bbox", listener_bbox);
      deferred_bbox.resolve();
    };
    var listener_load = function () {
      node.removeEventListener("load", listener_load);
      deferred_load.resolve();
    };

    node.addEventListener("bbox", listener_bbox.bind(this));
    node.addEventListener("load", listener_load.bind(this));

    // Thickening precision is based on the material solidity thresholds
    var solidity =
      1.45 * this.design.material.get_solidity_threshold(this.design.size);
    var deferred_thickening = this.design.modify_operation(
      opid || "",
      {
        surface: surface,
        thickness: solidity,
        id: thkid,
      },
      type
    );

    // After thickening operation is applied, we'll reload the model, then we can update the rest of the things (sizes, prices)
    $.when
      .apply(null, [deferred_bbox, deferred_load])
      .then(
        function () {
          this.controller.thickeningUpdated(type !== 2, type !== 0);
          deferred.resolve();
        }.bind(this)
      )
      .fail(
        function () {
          deferred.resolve();
        }.bind(this)
      );

    $.when
      .apply(null, [deferred_thickening])
      .then(
        function () {
          this.viewerUI.refreshModel({
            update_geometry: true,
            force_refresh: true,
          });
          //force the view to solifity check after thickneing have been applied
          this.viewerUI.toggle_solidity_check(false);
          //this.viewerUI.toggle_solidity_check(true);
          this.controller.toggleSolidityCheck(true);
          //this.controller.views.toolbar.changeView(sculpteo.PrintToolbarView.VIEWS.SOLIDITY_CHECK);

          if (type == 1)
            //show overlay message
            this.controller.overlayNotify(
              sculpteo.PrintOverlayNotification.TYPE.SAVED,
              gettext("Thickening has been applied"),
              false
            );
          else if (type == 2)
            this.controller.overlayNotify(
              sculpteo.PrintOverlayNotification.TYPE.RESET,
              gettext("Thickening is being removed"),
              false
            );
        }.bind(this)
      )
      .fail(function () {}.bind(this));

    return deferred;
  };
})((window.sculpteo = window.sculpteo || {}));
